import { useEffect } from 'react'
import { Outlet, useMatches } from 'react-router'
import { Sidebar } from './Sidebar'
import styles from './Layout.module.css'

export function Layout() {
  const matches = useMatches()
  const title = (matches.at(-1)?.handle as { title?: string } | undefined)?.title

  useEffect(() => {
    document.title = title ? `${title} — Fiket Admin` : 'Fiket Admin'
  }, [title])

  return (
    <div className={styles.root}>
      <Sidebar />
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  )
}
